import { useCallback } from 'react';
import { helpers } from '@minecraft.utils';

export const usePhoneFormat = (accountCountryCode: string): ((phone: string) => string) => {
  return useCallback((phone: string): string => helpers.formatPhone(phone, accountCountryCode), [accountCountryCode]);
};
